exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/core-js/modules/_wks-ext.js
// module id = fNwt
// module chunks = 1